'use client'
import styles from './FormBlock.module.scss'
import { useContext, useState } from 'react'
import { Block_Form } from '@/src/generated/graphql'
import { classNames } from '@/src/helpers/component'
import Button from '@/src/components/common/Button'
import WysiwygContent from '@/src/components/common/WysiwygContent'
import ContactUsFormFields from './FormBlock.ViewForm.ContactUs.client'
import WorkWithUsFormFields from './FormBlock.ViewForm.WorkWithUs.client'
import ReferAFriendFormFields from '@/src/components/blocks/ContentBlock/FormBlock/FormBlock.ViewForm.ReferAFriend.client'
import PartnerReferralFormFields from '@/src/components/blocks/ContentBlock/FormBlock/FormBlock.ViewForm.PartnerReferral.client'
import { DirectusContext } from '@/src/contexts/DirectusContext'
import { FormName } from '@/src/components/common/Form/Form.client'
import Form from '@/src/components/common/Form'

export default function ViewForm(
  _: Block_Form & { afterSubmitted: (arg0: { success: boolean }) => void },
) {
  const [isComplete, setIsComplete] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const directusContext = useContext(DirectusContext)
  const privacyPolicyPage = directusContext.SITE_SETTINGS.privacy_policy_page
  const referralTnCPage = directusContext.SITE_SETTINGS.referral_terms_and_conditions_page

  if (!privacyPolicyPage) {
    throw new Error('Privacy Policy Page not set in Site Settings')
  }

  if (!referralTnCPage) {
    throw new Error('Referral Terms and Conditions Page not set in Site Settings')
  }

  return (
    <Form
      className={styles.form}
      formName={_.form_type as FormName}
      afterChanged={({ isComplete }) => {
        setIsComplete(isComplete)
      }}
      beforeSubmit={() => {
        setIsSubmitting(true)
      }}
      afterSubmitted={({ success }) => {
        if (!success) setIsSubmitting(false)
        _.afterSubmitted({ success })
      }}>
      <div className={styles.formContent}>
        {(_.heading || _.content) && (
          <div className={classNames(styles.full, styles.headingsContainer)}>
            {_.heading && <h3 className={styles.heading}>{_.heading}</h3>}
            {_.content && <WysiwygContent content={_.content} className={styles.content} />}
          </div>
        )}
        {
          {
            contact_form: <ContactUsFormFields />,
            work_with_us_form: <WorkWithUsFormFields />,
            referralform: <ReferAFriendFormFields />,
            supplierreferral: <PartnerReferralFormFields />,
            newsletter_subscription: null,
            lead_form: null,
          }[_.form_type as FormName]
        }
        <div className={styles.full}>
          <label>
            <div className={styles.policies}>
              <input
                type={'checkbox'}
                name={'Privacy_Policy'}
                value={''}
                autoComplete={'off'}
                required
              />
              <div>
                I accept the{' '}
                <a href={`/${privacyPolicyPage.slug}/`} target={'_blank'}>
                  Privacy Policy
                </a>
              </div>
            </div>
          </label>
          {_.form_type === 'referralform' && (
            <label>
              <div className={styles.policies}>
                <input
                  type={'checkbox'}
                  name={'referrer_terms_and_conditions'}
                  value={''}
                  autoComplete={'off'}
                  required
                />
                <div>
                  I accept the{' '}
                  <a href={`/${referralTnCPage.slug}/`} target={'_blank'}>
                    Terms and conditions
                  </a>
                </div>
              </div>
            </label>
          )}
        </div>
        <hr className={classNames(styles.full, styles.divider)} />
        <div className={styles.full}>
          <Button disabled={!isComplete || isSubmitting} className={styles.submit}>
            {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
          </Button>
        </div>
      </div>
    </Form>
  )
}
